// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"993":"dc1b73e6dd0ba1bc","1870":"21206f3bf201551f","3868":"f6dbddbd316dc948","9146":"3cac876a99897e36","9979":"0f10f4e413d8529e"}[chunkId] + ".js";
};